import { Base64ToFile } from "./Base64ToFile";
import Resizer from "react-image-file-resizer";

export async function getResizer(file: any) {
  const res = new Promise((r) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      let image = new Image();
      image.src = reader.result + "";
      image.onload = async () => {
        const size = file.size / 1000;
        const qty = Math.max(50, Math.round((300 * 100) / size));

        if (image.width < 500) {
          const x = await Base64ToFile(reader.result);
          r(x);
        }

        if (image.width >= 500) {
          Resizer.imageFileResizer(
            file,
            image.width,
            image.height,
            "WEBP",
            size >= 1000 ? qty : 100,
            0,
            async (uri) => {
              const x = await Base64ToFile(uri);
              r(x);
            },
            "base64",
          );
        }
      };
    };
  });

  return res;
}
